module.exports = __webpack_public_path__ + "static/media/ResXS.ddea5ddf.pdf";